define([
    './defined',
    './defaultValue'
], function (
    defined,
    defaultValue
) {
    'use strict'

    const callbackSystem = {
        callbacks: {},
        has: function (type, objectName) {
            return !!this.callbacks[type + ":" + objectName]
        },
        register: function (type, objectName, callback) {
            this.callbacks[type + ":" + objectName] = callback
        },
        remove: function (type, objectName) {
            if (this.callbacks[type + ":" + objectName]) {
                delete this.callbacks[type + ":" + objectName]
                return true
            }else{
                return false
            }
        },
        clear: function () {
            this.callbacks = {}
        },
        call: function (type, objectName, ...args) {
            if (this.callbacks[type + ":" + objectName]) {
                return this.callbacks[type + ":" + objectName](...args)
            }
        }
    }
    /**
     * 注册回调管理器。
     *
     * @private
     *
     * @exports callbackSystem
     */
    Element.prototype.invokeCallback = (type, objectName, ...args) => {
        return callbackSystem.call(type, objectName, ...args)
    }
    return callbackSystem
})
